import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import './TreatmentGrid.scss';
import TreatmentCard from '../../components/TreatmentCard/TreatmentCard';
import TreatmentCategories from '../TreatmentCategories/TreatmentCategories';
import { getTreatments } from '../../services/treatmentService';

const TreatmentGrid = () => {
    const [activeCategory, setActiveCategory] = useState('estetik-dis-hekimligi');
    const [treatments, setTreatments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const fetchTreatments = async () => {
            try {
                const data = await getTreatments();
                setTreatments(data);
                setLoading(false);
            } catch (err) {
                console.error('Tedaviler yüklenirken hata:', err);
                setError('Tedaviler yüklenirken bir hata oluştu.');
                setLoading(false);
            }
        };

        fetchTreatments();
    }, []);

    // URL'den kategori parametresini al ve filtreyi ayarla
    useEffect(() => {
        const categoryParam = searchParams.get('category');
        if (categoryParam) {
            setActiveCategory(categoryParam);
        }
    }, [searchParams]);

    const filteredTreatments = activeCategory === 'all' 
        ? treatments 
        : treatments.filter(treatment => treatment.category === activeCategory);

    const handleCategoryChange = (categoryId) => {
        setActiveCategory(categoryId);
    };

    if (loading) return <div>Yükleniyor...</div>;
    if (error) return <div>{error}</div>;

    return (
        <>
            <TreatmentCategories 
                onCategoryChange={handleCategoryChange}
                activeCategory={activeCategory}
            />
            <section className="treatment-grid">
                <div className="container">
                    {filteredTreatments.length === 0 ? (
                        <div className="row justify-content-center">
                            <div className="col-12 text-center">
                                <p style={{ color: '#666', fontSize: '18px', marginTop: '50px' }}>
                                    Bu kategoride henüz tedavi bulunmamaktadır.
                                </p>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            {filteredTreatments.map((treatment) => (
                                <div key={treatment.id} className="col-lg-4 col-md-6 col-sm-12">
                                    <TreatmentCard treatment={treatment} />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </>
    );
};

export default TreatmentGrid; 